import { render, staticRenderFns } from "./GBuyerSideNavigation.vue?vue&type=template&id=6e944739&scoped=true&"
import script from "./GBuyerSideNavigation.vue?vue&type=script&lang=ts&"
export * from "./GBuyerSideNavigation.vue?vue&type=script&lang=ts&"
import style0 from "./GBuyerSideNavigation.vue?vue&type=style&index=0&id=6e944739&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e944739",
  null
  
)

export default component.exports